"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("react"),r=require("../../utility/object/object.js");exports.default=function(t){var u=e.useRef(t);return r.isEqual(u.current,t)||(u.current=t),u.current};
